import {LeasingCellCoordinates} from '../../types/LeasingCellCoordinates';
import {getLeasingCellKey} from './getLeasingCellKey';

export function isSameLeasingCell(left: LeasingCellCoordinates, right: LeasingCellCoordinates) {
  return getLeasingCellKey(left) === getLeasingCellKey(right);
}
